import { useAppTranslation } from '@hooks/useAppTranslation';
import { useSharedStackScreenOptions } from '@hooks/useSharedStackScreenOptions';
import { Stack } from 'expo-router';

export default function BoardLayout(): React.ReactNode {
  const { t } = useAppTranslation();
  const screenOptions = useSharedStackScreenOptions();

  return (
    <Stack screenOptions={screenOptions}>
      <Stack.Screen
        name="index"
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="reports/[reportId]"
        options={{
          headerTitle: t('reports.detailTitle', 'Report details'),
        }}
      />
      <Stack.Screen
        name="reports/[reportId]/edit/index"
        options={{
          headerTitle: t('reportCreation.editTitle'),
        }}
      />
      <Stack.Screen
        name="reports/[reportId]/edit/similar/index"
        options={{
          headerTitle: t('reportCreation.similarReports.title'),
        }}
      />
      <Stack.Screen
        name="reports/[reportId]/edit/version-note/index"
        options={{
          headerTitle: t('reportCreation.versionNote.title'),
        }}
      />
      <Stack.Screen
        name="reports/[reportId]/edit/request-rra/success"
        options={{
          headerShown: false,
        }}
      />
    </Stack>
  );
}
